import { render, staticRenderFns } from "./ActList.vue?vue&type=template&id=36ca5089&scoped=true"
import script from "./ActList.vue?vue&type=script&lang=js"
export * from "./ActList.vue?vue&type=script&lang=js"
import style0 from "./ActList.vue?vue&type=style&index=0&id=36ca5089&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ca5089",
  null
  
)

export default component.exports